<template>
    <b-row v-if="row.errordata === 'Error'">
        <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
        <a @click="showDialog">{{ row.errorshorttext }}</a>
    </b-row>
</template>

<script>
import ECMErrorDialog from '../modals/ECMCrawlerMessageDlg.vue';
import { showMessage} from '../../utils/commonECM.js';

export default {
    data() {
        return {
            messageDlg: false,
        }
    },
    props: ['row'],
    
    components: {
      ECMErrorDialog
    },

    created() {
        var that = this;
        const a = that;
    },

    methods: {
        showDialog() {
            var that = this;
            showMessage(this, 'error', that.row.description, that.row.errordata, true, that.row.errordescription);
        }
    }
}

</script>